<template>
    <div class="block-editor custom-webhook">
        <div class="editor-row">
            <div class="editor-row-title">URL</div>
            <TiptapEditor placeholder="Enter URL" :show-attributes="true" :show-emoji="false" v-model="clone.url" />
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Method</div>
            <a-select v-model="clone.method">
                <a-select-option v-for="method in httpMethods" :value="method" :key="method">{{
                    method
                }}</a-select-option>
            </a-select>
        </div>
        <div class="editor-row">
            <div class="editor-row-title">Headers</div>
            <div v-for="(header, index) in clone.headers" :key="'header-' + index" class="key-value-pair">
                <a-input v-model="header.key" placeholder="Header Key" class="key-input" />
                <TiptapEditor
                    v-model="header.value"
                    placeholder="Header Value"
                    :show-attributes="true"
                    :show-emoji="false"
                />
                <a-button type="link" danger @click="removeHeader(index)">
                    <span class="material-icons">delete</span>
                </a-button>
            </div>
            <a-button type="dashed" block @click="addHeader" class="add-btn">
                <span class="material-icons">add</span> Add Header
            </a-button>
        </div>
        <template v-if="showBodySection">
            <div class="editor-row">
                <div class="editor-row-title">Body Type</div>
                <a-select v-model="clone.bodyFormat">
                    <a-select-option value="json">JSON</a-select-option>
                    <a-select-option value="formData">Form Data</a-select-option>
                    <a-select-option value="urlencoded">URL Encoded</a-select-option>
                    <a-select-option value="raw">Raw</a-select-option>
                    <a-select-option value="raw-json">Raw JSON</a-select-option>
                </a-select>
            </div>
            <div class="editor-row">
                <div class="editor-row-title">Body</div>
                <template v-if="clone.bodyFormat !== 'raw-json'">
                    <div v-for="(bodyItem, index) in clone.body" :key="'body-' + index" class="key-value-pair">
                    <a-input v-model="bodyItem.key" placeholder="Body Key" class="key-input" />
                    <TiptapEditor
                        v-model="bodyItem.value"
                        placeholder="Body Value"
                        :show-attributes="true"
                        :show-emoji="false"
                    />
                    <a-button type="link" danger @click="removeBody(index)">
                        <span class="material-icons">delete</span>
                    </a-button>
                    </div>
                    <a-button type="dashed" block @click="addBody" class="add-btn">
                        <span class="material-icons">add</span> Add Body Parameter
                    </a-button>
                </template>
                <TiptapEditor v-if="clone.bodyFormat === 'raw-json'" v-model="clone.rawJson"
                    placeholder="Paste JSON here"
                    :show-attributes="true"
                    :show-emoji="false"
                />

            </div>
        </template>
        <div class="editor-row">
            <div class="editor-row-title">Example Response</div>
            <SupsisButton primary @click="showResponseModal = true">SET RESPONSE</SupsisButton>
        </div>
        <Modal2 v-if="showResponseModal" title="Set Example Response" @cancel="handleCancel" @ok="saveResponse">
            <template #default>
                <a-textarea v-model="responseInput" placeholder="Paste JSON/Response here" rows="10" />
            </template>
        </Modal2>
    </div>
</template>

<script>
import _ from "lodash";
import TiptapEditor from "../common/TiptapEditor";
import Modal2 from "../../../../../../components/common/Modal2.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";

export default {
    name: "CustomWebhook",
    components: { TiptapEditor, Modal2, SupsisButton },
    props: ["value"],
    data() {
        const clone = _.cloneDeep(this.value) || {
            url: "",
            method: "POST",
            headers: [],
            body: [],
            bodyFormat: "json",
            rawJson: "",
            exampleResponseModel: {
                success: true,
                status: 200,
                statusText: "OK",
                data: {},
                headers: {},
                request: {
                    url: "",
                    method: "POST",
                    headers: {},
                    body: {},
                },
            },
        };
        return {
            clone,
            httpMethods: ["POST", "PUT", "GET", "DELETE", "PATCH"],
            showResponseModal: false,
            responseInput: JSON.stringify(this.$_.get(clone, "exampleResponseModel.data", {}) || ""),
        };
    },
    computed: {
        showBodySection() {
            const validMethods = ["POST", "PUT", "PATCH"];
            return validMethods.includes(this.clone.method);
        },
    },
    methods: {
        addHeader() {
            if (!Array.isArray(this.clone.headers)) {
                this.clone.headers = [];
            }
            this.clone.headers.push({ key: "", value: "" });
        },
        removeHeader(index) {
            this.clone.headers.splice(index, 1);
        },
        addBody() {
            if (!Array.isArray(this.clone.body)) {
                this.clone.body = [];
            }
            this.clone.body.push({ key: "", value: "" });
        },
        removeBody(index) {
            this.clone.body.splice(index, 1);
        },
        handleCancel() {
            this.showResponseModal = false;
        },
        saveResponse() {
            try {
                this.clone.exampleResponseModel = {
                    success: true,
                    status: 200,
                    statusText: "OK",
                    data: {},
                    headers: {},
                    request: {
                        url: "",
                        method: "POST",
                        headers: {},
                        body: {},
                    },
                };
                this.clone.exampleResponseModel.data = JSON.parse(this.responseInput);
                this.showResponseModal = false;
            } catch (error) {
                alert("Invalid JSON");
            }
        },
    },
    watch: {
        clone: {
            deep: true,
            handler(newValue) {
                this.$emit("input", newValue);
            },
        },
        "clone.method": {
            handler(newValue) {
                // Method değiştiğinde body gerektirmeyen bir metoda geçilirse body'i temizle
                if (!this.bodyMethods.includes(newValue)) {
                    this.clone.body = [];
                    this.clone.bodyFormat = "json";
                }
            },
        },
    },
};
</script>

<style lang="scss">
.block-editor.custom-webhook {
    padding: 20px;
    overflow-x: hidden; // Ana container'da yatay kaymayı önle

    .editor-row {
        margin-bottom: 20px;

        .editor-row-title {
            font-weight: bold;
            margin-bottom: 10px;
            font-size: 16px;
        }
    }

    .key-value-pair {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        min-width: 0; // Flexbox'ta taşmayı önlemek için

        .key-input {
            width: 200px;
            flex-shrink: 0; // Key input'un boyutu sabit kalsın
        }

        .material-icons {
            font-size: 20px;
            flex-shrink: 0; // Icon'un boyutu sabit kalsın
        }

        // TiptapEditor için özel stil
        .editable-editor-wrapper {
            flex: 1;
            min-width: 0; // Flexbox'ta taşmayı önlemek için
            max-width: 100%;
            overflow: visible; // text-editor-utils ikonlarının görünmesi için
            position: relative; // Absolute positioned ikonlar için

            .editable-editor {
                max-width: 100%;
                overflow: hidden;

                .ProseMirror {
                    max-width: 100%;
                    overflow: hidden;
                    word-break: break-word; // Uzun kelimeleri kır
                    text-overflow: ellipsis;
                    
                    p {
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap; // Tek satır için
                        margin: 0;
                        
                        // Çok uzun içerik için çok satırlı gösterim (opsiyonel)
                        // display: -webkit-box;
                        // -webkit-line-clamp: 3;
                        // -webkit-box-orient: vertical;
                        // white-space: normal;
                    }
                }
            }

            // text-editor-utils ikonlarının görünür olması için
            .text-editor-utils {
                position: absolute;
                right: 5px;
                bottom: -10px;
                z-index: 16;
                pointer-events: auto;
            }
        }
    }

    .add-btn {
        margin-top: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;

        .material-icons {
            font-size: 18px;
        }
    }

    // URL ve Body için direkt TiptapEditor kullanılan yerler
    .editor-row {
        .editable-editor-wrapper {
            max-width: 100%;
            overflow: visible; // text-editor-utils ikonlarının görünmesi için
            position: relative; // Absolute positioned ikonlar için

            .editable-editor {
                max-width: 100%;
                overflow: hidden;

                .ProseMirror {
                    max-width: 100%;
                    overflow: hidden;
                    word-break: break-word;
                    text-overflow: ellipsis;
                    
                    p {
                        max-width: 100%;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                        margin: 0;
                    }
                }
            }

            // text-editor-utils ikonlarının görünür olması için
            .text-editor-utils {
                position: absolute;
                right: 5px;
                bottom: -10px;
                z-index: 16;
                pointer-events: auto;
            }
        }
    }
}
</style>
